module.exports = __webpack_public_path__ + "static/media/beeren.f59109e0.png";